import { defineComponent as _defineComponent } from 'vue'
import { PropType, Ref, ref } from 'vue';
import IconCheckmark from '@/components/svg/checkmark.svg?inline';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXCheckbox',
  props: {
  value: Boolean,
  readonly: Boolean,
  isRadio: Boolean,
  invalid: Boolean,
  type: {
    type: String as PropType<'normal' | 'dark' | 'outlined'>,
    default: 'normal'
  },
  align: {
    type: String as PropType<'top' | 'center'>,
    default: 'center'
  },
  gap: {
    type: String,
    default: '12px'
  },
  isBoxOutside: Boolean
},
  emits: ['input'],
  setup(__props, { emit }) {




const input = ref(null) as Ref<HTMLInputElement | null>;

const onChange = () => {
  const isChecked = !!input?.value?.checked;
  emit('input', isChecked);
};


return { __sfc: true,emit, input, onChange, IconCheckmark }
}

})